import React from 'react';
import './pdp-carousel.scss';
import ImageOverlay from '../../common/ImageOverlay/ImageOverlay';
import Swipe from '../SwipeAction/Swipe';
import ImageIndicator from '../ImageIndicator/ImageIndicator';
import PropTypes from 'prop-types';
import ImageSwitcher from './../ImageSwitcher/ImageSwitcher';

class PDPCarousel extends React.Component {
  constructor(props) {
    super(props);
    this.state = { activeIndex: 0 };
    this.carouselRef = React.createRef();
    // this.uniqueKey = `uk-${Math.round(Math.random() * 1000000)}`;
    // console.log('Uk: ', this.uniqueKey);
    this.swiper = null;
  }

  // shouldComponentUpdate(nextProps, nextState, nextContext) {
  //   return undefined !== nextProps.activeIndex && nextProps.activeIndex !== this.props.activeIndex
  // }

  componentDidMount() {
    if (this.props.images?.length > 1 && !this.props.desktop) {
      this.registerSwipe();
    }
  }

  registerSwipe = () => {
    const container = this.carouselRef.current;
    const swiper = new Swipe(container);
    swiper.onLeft(() => {
      // console.log('Swiped Left: ');
      this.slide('left');
    });
    swiper.onRight(() => {
      // console.log('Swiped Right: ');
      this.slide('right');
    });
    swiper.run();
    this.swiper = swiper;
  };
  componentWillUnmount() {
    if (this.props.images?.length > 1 && this.swiper) {
      this.swiper.stop();
    }
  }
  getImages = () => {
    const { imageClassName, soldOut, altText } = this.props;
    const carousels = this.props.images.map((img, index) => {
      return (
        <div className={imageClassName} key={index}>
          <ImageOverlay>
            <img
              src={img}
              className={`carousel-image ${soldOut ? 'sold-out' : ''}`}
              alt={altText}
            />
          </ImageOverlay>
        </div>
      );
    });
    return carousels;
  };
  slide = dir => {
    const { activeIndex } = this.state;
    const { carouselRef } = this;
    const width = this.carouselRef.current?.childNodes[1]?.clientWidth || 0;
    let scrollWidth = 0,
      nextIndex = activeIndex;
    // console.log('dir: ', dir, width,)
    if (dir === 'left') {
      // show next Image
      // console.log('Sliding to next image: ');
      if (activeIndex < this.props.images.length - 1) {
        nextIndex = activeIndex + 1;
        scrollWidth = nextIndex * width;
      }
    } else if (dir === 'right') {
      // show previous image
      // console.log('Sliding to previous image: ');
      if (activeIndex > 0) {
        nextIndex = activeIndex - 1;
        scrollWidth = nextIndex * width;
      }
    }
    if (nextIndex !== activeIndex) {
      // console.log('Scrolling to image? ', nextIndex, scrollWidth);
      carouselRef.current.scroll({ left: scrollWidth, behavior: 'smooth' });
      this.setState({ activeIndex: nextIndex });
    }
  };

  render() {
    const { images, indicatorClassName, desktop } = this.props;
    const { activeIndex } = this.state;
    return (
      <React.Fragment>
        {images?.length > 0 && (
          <React.Fragment>
            <div className="pdp-carousel" ref={this.carouselRef}>
              {this.getImages()}
            </div>
            {images?.length > 1 && (
              <div className={indicatorClassName}>
                <ImageIndicator
                  count={images.length}
                  activeIndex={activeIndex}
                />
              </div>
            )}
            {images?.length > 1 && desktop && (
              <ImageSwitcher
                onNext={() => this.slide('left')}
                onPrevious={() => this.slide('right')}
              />
            )}
          </React.Fragment>
        )}
        {(!images || !images.length) && false}
      </React.Fragment>
    );
  }
}

PDPCarousel.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string),
  soldOut: PropTypes.bool,
  indicatorClassName: PropTypes.string,
  imageClassName: PropTypes.string,
  desktop: PropTypes.bool,
  // activeIndex: PropTypes.number,
  // afterSwipe: PropTypes.func,
};

PDPCarousel.defaultProps = {
  indicatorClassName: 'pdp-carousel--image-indicator',
  desktop: false,
  imageClassName: 'pdp-carousel--carousel-image',
};

export default PDPCarousel;
